var Acr = Acr || {};

Acr.Zipgate = function () {
  var $body;
  var $zipGate;
  var $zipGateCloseBtn;
  var $zipGateSpinner;
  var $zipGateGeoError;
  var $zipGateZipCodeError;
  var $zipGateFormInput;
  var $zipGateFormBtn;
  var $zipGateAllowBtn;
  const closeButtonSelectorClass = '.js-zipgate-close';
  const zipgateSelectorClass = '.js-zipgate';
  const spinnerSelectorClass = '.js-zipgate-spinner';
  const geoErrorSelectorClass = '.js-zipgate-geo-error';
  const zipCodeErrorSelectorClass = '.js-zipgate-code-error';
  const formInputSelectorClass = '.js-zipgate-form-input';
  const formButtonSelectorClass = '.js-zipgate-form-button';
  const allowButtonSelectorClass = '.js-zipgate-allow';
  const showZipgate = '.js-zipgate.show';
  const bodyTagSelector = 'body';
  const showClass = 'show';
  const modalOpenClass = 'modal-open';
  const geoService = '/platform/api/v1/zipcode/ip';
  var zipcodeValue;
  var zipcodeUpdateEvent;
  var callback;
  var callbackEvent;

  const zipgateElement = document.querySelector(zipgateSelectorClass);
  const focusableElements = '.js-zipgate-close:not([style*="display: none"]), button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const closeElement = zipgateElement.querySelector(closeButtonSelectorClass);
  const focusableContent = zipgateElement.querySelectorAll(focusableElements);
  const firstFocusableElement = closeElement && window.getComputedStyle(closeElement).display !== 'none'
    ? focusableContent[0] : focusableContent[1]; // get first element to be focused inside modal
  const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  const preFocusableElement = focusableContent[focusableContent.length - 2];

  document.addEventListener('keydown', function (e) {
    if (closeElement) {
      closeElement.removeAttribute('focusable');
      closeElement.setAttribute('tabindex', '0');
    }
    var activeElementClass = document.activeElement.getAttribute('class');
    var currentElement = zipgateElement.getElementsByClassName(activeElementClass);
    var isZipgateOpen = document.querySelector(showZipgate);
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    let isIE = Utility.isIE11();

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey && !isIE) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        if (lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null) {
          preFocusableElement.focus(); // add focus for the last focusable element
          e.preventDefault();
        } else {
          lastFocusableElement.focus();
          e.preventDefault();
        }

      }
    } if (!e.shiftKey && !isIE) {
      if (document.activeElement === lastFocusableElement
      || (lastFocusableElement !== null && lastFocusableElement.getAttribute('disabled') !== null && document.activeElement === preFocusableElement)
      && (isZipgateOpen !== null)) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      } else if (currentElement.length === 0 && isZipgateOpen !== null) {
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });

  function triggerFormTaggingClick() {
    try {
      var stringObject = $zipGateFormBtn.getAttribute('data-form-submit-tracking') || '';
      var clickObject = JSON.parse(stringObject.split("'").join('"'));

      if (clickObject && Acr.TrackingManager) {
        Acr.TrackingManager.clickActivity(clickObject);
      }
    } catch (err) {
      console.warn('ERROR AT TRACKING OBJECT: ' + err);
    }
  }

  function getZipcode() {
    var zipcode = Utility.getUrlParameterValue('zipcode');

    if (typeof zipcode === 'string') {
      zipcode = zipcode.replace(/\D/g, '');
    }

    if (!zipcode) {
      zipcode = Utility.getCookie('zipcode');
      if (zipcode && zipcode !== 'false') {
        return zipcode;
      }
      return false;

    }
    return zipcode;
  }

  function triggerTaggingPage(trackingObject) {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad(trackingObject);
    } else {
      // this event will be triggered once that
      // TrackingManager.js is loaded. Used to avoid dependencies issues.
      window.addEventListener('trackingPageload', function runPageLoad() {
        if (Acr.TrackingManager) {
          Acr.TrackingManager.pageLoad(trackingObject);
        }
      });
    }
  }

  function trackingOpenZipgate() {
    if (Acr.TrackingManager) {
      Acr.TrackingManager.savePageLoadObject();
    }

    const tempTrackingObject = window.Acr.trackingObject;
    var trackingObject = { // eslint-disable-line no-unused-vars
      Model: {
        model_name: 'no model',
        model_year: 'no model',
        body_style: 'no model',
      },
      Page: {
        site_section: 'global',
        page_name: window.Acr.pageName ? window.Acr.pageName + ' Location Access Modal' : '',
        sub_section: window.Acr && window.Acr.trackingObject ? window.Acr.trackingObject.Page.sub_section : '',
        sub_section2: window.Acr && window.Acr.trackingObject ? window.Acr.trackingObject.Page.sub_section2 : '',
      },
    };

    if (tempTrackingObject) {
      if (tempTrackingObject.Model) {
        trackingObject.Model = tempTrackingObject.Model;
      }

      if (tempTrackingObject.Page && tempTrackingObject.Page.page_name && tempTrackingObject.Page.sub_section) {
        trackingObject.Page.page_name = tempTrackingObject.Page.page_name + ' Location Access Modal';
        trackingObject.Page.sub_section = tempTrackingObject.Page.sub_section;
      }
    }

    triggerTaggingPage(trackingObject);
  }

  function setZipcode(zipcode) {
    var url = document.location.href;
    var redirect = $zipGate.getAttribute('data-redirect');
    Utility.setCookie('zipcode', zipcode);
    $zipGateGeoError.classList.remove(showClass);

    if (callback && callbackEvent) {
      callback(callbackEvent);
      zipcodeUpdateEvent = Utility.createEvent('zipcodeUpdate', { zipcode: zipcode });
      window.dispatchEvent(zipcodeUpdateEvent);
      closeZipgate();
    } else if (String(redirect).toLowerCase() === 'true') {
      closeZipgate();
      if (url.indexOf('?') !== -1) {
        url = url + '&zipcode=' + zipcode;
      } else {
        url = url + '?zipcode=' + zipcode;
      }
      document.location = url;
    } else {
      closeZipgate();
      zipcodeUpdateEvent = Utility.createEvent('zipcodeUpdate', { zipcode: zipcode });
      window.dispatchEvent(zipcodeUpdateEvent);
    }
  }

  function showError() {
    $zipGateZipCodeError.classList.add(showClass);
  }

  function validZipcodeSubmit() {
    setZipcode(zipcodeValue);
  }

  function sendZipcode(e) {
    e.stopPropagation();
    e.preventDefault();
    triggerFormTaggingClick();
    Utility.validateZipcode(zipcodeValue, validZipcodeSubmit, showError);
  }

  function validateZipCode() {
    var inputValue = $zipGateFormInput.value;
    var validZipcode = new RegExp(/^\d{5}$/);
    $zipGateZipCodeError.classList.remove(showClass);

    if (inputValue.match(validZipcode)) {
      $zipGateFormBtn.disabled = false;
      zipcodeValue = inputValue;
    } else {
      $zipGateFormBtn.disabled = true;
      zipcodeValue = false;
    }
  }

  function allowGeolocation() {
    let beforeSend = function () {
      $zipGateSpinner.classList.add(showClass);
    };

    const request = new XMLHttpRequest();
    request.open('GET', geoService, true);
    request.onload = function (data) {
      const response = JSON.parse(data.currentTarget.response);
      const zipCode = response.GeoIpData.postalCode;

      if (response.ResolveState === 1) {
        setZipcode(zipCode);
      } else {
        $zipGateGeoError.classList.add(showClass);
      }

      $zipGateSpinner.classList.remove(showClass);
    };
    request.setRequestHeader('Content-Type', 'application/json');
    beforeSend();
    request.send();
  }

  function closeZipgate() {
    $body.classList.remove(modalOpenClass);
    $zipGate.classList.remove(showClass);
    $zipGateFormInput.value = null;
    $zipGateFormBtn.disabled = true;

    if (Acr.TrackingManager) {
      Acr.TrackingManager.restorePageLoadObject();
    }
  }

  function openZipgate(callbackParam, event, cloneEvent = false, hideCloseButton = false) {
    trackingOpenZipgate();

    if (callbackParam) {
      callback = callbackParam;
      callbackEvent = cloneEvent ? Object.assign({}, event) : event;
    }

    $zipGate.classList.add(showClass);
    $body.classList.add(modalOpenClass);
    if (hideCloseButton) { 
      $zipGateCloseBtn.classList.add('hide');
    }
  }

  function initSelectors(element) {
    $zipGate = element;
    $zipGateCloseBtn = $zipGate.querySelector(closeButtonSelectorClass);
    $zipGateSpinner = $zipGate.querySelector(spinnerSelectorClass);
    $zipGateGeoError = $zipGate.querySelector(geoErrorSelectorClass);
    $zipGateZipCodeError = $zipGate.querySelector(zipCodeErrorSelectorClass);
    $zipGateFormInput = $zipGate.querySelector(formInputSelectorClass);
    $zipGateFormBtn = $zipGate.querySelector(formButtonSelectorClass);
    $zipGateAllowBtn = $zipGate.querySelector(allowButtonSelectorClass);
    $body = document.querySelector(bodyTagSelector);
  }

  function bindEvents() {
    if ($zipGateCloseBtn) {
      $zipGateCloseBtn.addEventListener('click', closeZipgate);
      $zipGateCloseBtn.addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          closeZipgate();
        }
      });
    }
    $zipGateAllowBtn.addEventListener('click', allowGeolocation);
    $zipGateFormInput.addEventListener('keyup', validateZipCode);
    $zipGateFormBtn.addEventListener('click', sendZipcode);
  }

  function init(element) {
    initSelectors(element);
    bindEvents();
  }

  return {
    init: init,
    getZipcode: getZipcode,
    openZipgate: openZipgate,
  };
};
